// src/components/CameraScanner.js
import React, { useRef, useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';

const CameraScanner = ({ onCapture }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [error, setError] = useState('');

  // Start camera stream when the component mounts
  useEffect(() => {
    const startCamera = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
        setStream(mediaStream);
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
        }
      } catch (err) {
        setError('Error accessing camera.');
      }
    };

    startCamera();

    // Clean up camera stream when component unmounts
    return () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [stream]);

  // Capture the image from the video stream
  const handleCapture = () => {
    if (videoRef.current && canvasRef.current) {
      const context = canvasRef.current.getContext('2d');
      const video = videoRef.current;

      // Set canvas dimensions to match the video dimensions
      canvasRef.current.width = video.videoWidth;
      canvasRef.current.height = video.videoHeight;

      // Draw the current video frame to the canvas
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

      // Convert the canvas to a data URL (Base64 image)
      const imageDataURL = canvasRef.current.toDataURL('image/png');
      
      // Pass the image data to the parent component
      onCapture(imageDataURL);
    }
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      {error && <Typography color="error">{error}</Typography>}
      <video ref={videoRef} autoPlay playsInline style={{ width: '100%', maxHeight: '400px' }} />
      <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
      <Button variant="contained" color="primary" onClick={handleCapture} sx={{ marginTop: '10px' }}>
        Capture Image
      </Button>
    </Box>
  );
};

export default CameraScanner;
